module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-icon-04d7f4efc3aae82ebc8da36652212297.svg";